import { render } from "./TuDoudb.vue?vue&type=template&id=71c5bc03&scoped=true"
import script from "./TuDoudb.vue?vue&type=script&lang=js"
export * from "./TuDoudb.vue?vue&type=script&lang=js"

import "./TuDoudb.vue?vue&type=style&index=0&id=71c5bc03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c5bc03"]])

export default __exports__